import { LandingFooter } from '../../../../components/_external-pages/landing';
import { LandingFooterProps } from '../../../../components/_external-pages/landing/LandingFooter';

const props: LandingFooterProps = {
  address: 'Colima 152, Col. Roma Norte. Del. Cuauhtémoc. CDMX 06700 México',
  copy: '© 2022 Todos los derechos reservados. Prohibida su reproducción total o parcial sin el permiso de iBAN Online.',
  contact: {
    email: 'hola@ibanonline.com.mx',
    phone: '+55 4445 9254',
    title: 'CONTÁCTANOS'
  },
  sections: [
    {
      title: 'Productos',
      links: [
        {
          text: 'Crédito Solución',
          hashLink: false,
          to: '/productos/credito-solucion'
        },
        {
          text: 'Crédito Comercial',
          hashLink: false,
          to: '/productos/credito-comercial'
        },
        {
          text: 'Crédito Construcción',
          hashLink: false,
          to: '/productos/credito-construccion'
        },
        {
          text: 'Mejora tu cuota',
          hashLink: false,
          to: '/productos/mejora-tu-cuota'
        },
        {
          text: 'Refiere y gana',
          hashLink: false,
          to: '/refiere-y-gana'
        }
      ]
    },
    {
      title: 'Conócenos',
      links: [
        {
          text: 'Nosotros',
          hashLink: false,
          to: '/nosotros'
        },
        {
          text: 'Aviso de privacidad',
          hashLink: false,
          to: '/aviso-de-privacidad'
        },
        {
          text: 'Términos y condiciones',
          hashLink: false,
          to: '/terminos-y-condiciones'
        },
        {
          text: 'Política de Cookies',
          hashLink: false,
          to: '/politica-de-cookies'
        },
        {
          text: 'Autorización de uso de medios electrónicos',
          hashLink: false,
          to: '/autorizacion-de-uso-de-medios-electronicos'
        }
      ]
    },
    {
      title: 'Agentes',
      links: [
        {
          text: 'Beneficios',
          hashLink: true,
          to: '/agentes#beneficios'
        },
        {
          text: 'Únete ahora',
          hashLink: false,
          to: '/agentes/register'
        },
        {
          text: '¿Cómo funciona?',
          hashLink: true,
          to: '/agentes#como-funciona'
        }
      ]
    }
  ]
};

export const HomeFooter = () => {
  return <LandingFooter {...props} />;
};
